import { useState } from "react";
import "./App.css";
import PopForm from "./Components/PopForm";
import Footer from "./Footer";
import Header from "./Header";
import Hero from "./Hero";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Table1 from "./Table1";
import Table2 from "./Table2";

function App() {
  const [popUpActive, setPopUpActive] = useState({
    active: false,
    type: "",
  });

  const handleActivePopUp = (type) => {
    setPopUpActive({
      active: !popUpActive.active,
      type: type,
    });
  };

  const animation = {
    initial: { opacity: 0, y: -60, skewX: -3, skewY: -3 },
    inView: { opacity: 1, y: 0, skewX: 0, skewY: 0 },
  };

  return (
    <div className="App">
      {/* PopUp */}
      <PopForm popUpActive={popUpActive} setPopUpActive={setPopUpActive} />

      <Header />
      <Hero handleActivePopUp={handleActivePopUp} variants={animation} />
      <Section1 variants={animation} />
      <Section2 handleActivePopUp={handleActivePopUp} variants={animation} />
      <Section3 handleActivePopUp={handleActivePopUp} variants={animation} />
      <Section4 handleActivePopUp={handleActivePopUp} variants={animation} />
      <Table1 variants={animation} />
      <Section5 handleActivePopUp={handleActivePopUp} variants={animation} />
      <Section6 variants={animation} />
      <Section7 handleActivePopUp={handleActivePopUp} variants={animation} />
      <Table2 variants={animation} />
      <Section8 handleActivePopUp={handleActivePopUp} variants={animation} />
      <Footer handleActivePopUp={handleActivePopUp} variants={animation} />
    </div>
  );
}

export default App;
